import { apiClient } from "@/lib/api/client";
import { User } from "@/lib/types/auth";

export interface LoginResponse {
  user: User;
  access: string;
  refresh: string;
}

export const completeGoogleLogin = async (
  code: string,
  callback_url: string
): Promise<LoginResponse> => {
  if (!code) throw new Error("Google login code is not provided");

  const response = await apiClient.post<LoginResponse>("/google-login/", {
    code,
    callback_url,
  });

  const { user, access, refresh } = response.data;

  if (!user || !access || !refresh) {
    throw new Error("Invalid response format from login endpoint");
  }

  return {
    user,
    access,
    refresh,
  };
};

export const getCurrentUser = async (): Promise<User> => {
  const response = await apiClient.get<User>("/users/me/");
  return response.data;
};